"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation initializePlannerService(
        $plannerType: String
        $lotNumber: String
    ) {
        initializePlanner(
            input: { plannerType: $plannerType, lotNumber: $lotNumber }
        ) {
            clientMutationId
        }
    }
`;exports.initializePlanner=e;
//# sourceMappingURL=queries.js.map
